import { render, staticRenderFns } from "./Colxx.vue?vue&type=template&id=bee4fb94&"
import script from "./Colxx.vue?vue&type=script&lang=js&"
export * from "./Colxx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports